import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Alert, Form } from 'antd';
import { FormControls } from './ReportFormControls';
import { Table } from './ReportTable';
import { loadAllDictionaryReportSummary } from '../../../../redux/asyncActions/reportSummaryDictionaries';
import { loadReportKinds } from '../../../../redux/asyncActions/reportStatus';

export const ReportStatus = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { isLoadingDictionaries, error } = useSelector((state) => ({
    isLoadingDictionaries: state.reportSummaryDictionaries.isLoadingDictionaries,
    error: state.reportSummaryDictionaries.error,
  }));

  useEffect(() => {
    dispatch(loadAllDictionaryReportSummary());
    dispatch(loadReportKinds());
  }, [dispatch]);

  if (isLoadingDictionaries) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Spin size='large' />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message='Ошибка'
        description='Не удалось загрузить справочники. Попробуйте обновить страницу.'
        type='error'
        showIcon
      />
    );
  }

  return (
    <div>
      <FormControls form={form} />
      <Table />
    </div>
  );
};
